import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DataResolverService } from './core/services/data-resolver.service';
import { AuthPageComponent } from './features/account/auth-page/auth-page.component';
import { PageNotfoundComponent } from './features/account/page-notfound/page-notfound.component';
import { ForbiddenComponent } from './features/account/forbidden/forbidden.component';
import { ForcedPasswordChangeComponent } from './features/account/forced-password-change/forced-password-change.component';
//import { DefaultLayoutComponent } from './core/components/default-layout/default-layout.component';

const routes: Routes = [
  { path: 'login', component: AuthPageComponent },
  { path: 'forgot-password', component: AuthPageComponent },
  { path: 'forced-password-change', component: ForcedPasswordChangeComponent },
  { path: 'PageNotFound', component: PageNotfoundComponent },
  { path: '403', component: ForbiddenComponent },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  { path: '', loadChildren: () => import('./core/core.module').then((m) => m.CoreModule) },
  { path: '**', redirectTo: 'PageNotFound' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'ignore' })],
  exports: [RouterModule],
  providers: [DataResolverService]
})
export class AppRoutingModule { }
